import React from "react";
import type { MenuProps } from "antd";
import { Dropdown, Modal, message } from "antd";
import styled from "@emotion/styled";
import { dotdotdot } from "assets/icons";
import {
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useCancelHandshake } from "hooks/useAgents";
import { useNavigate } from "react-router-dom";

interface DropDownAgentProps {
  id: string;
}

const { confirm } = Modal;

const DropDownAgent: React.FC<DropDownAgentProps> = ({ id }) => {
  const { mutate,  } = useCancelHandshake();

  const navigate = useNavigate();


  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <ExclamationCircleOutlined />
          <div style={{ marginLeft: 5 }}>รายงานตัวแทน</div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <ExclamationCircleOutlined />
          <div style={{ marginLeft: 5 }}> ขอบล็อค/ยกเลิกตัวแทน</div>
        </div>
      ),
      onClick: () => {
        // dialog confirm
        confirm({
          title: "คุณต้องการยกเลิกตัวแทนใช่หรือไม่",
          icon: <ExclamationCircleFilled />,
          content: "คุณต้องการยกเลิกตัวแทนใช่หรือไม่",
          okText: "Yes",
          okType: "danger",
          cancelText: "No",
          onOk() {
            mutate(
              { agent_id: id, message: "" },
              {
                onSuccess: () => {
                  message.success("ยกเลิกตัวแทนสำเร็จ");
                  //refetch();
                 // queryClient.invalidateQueries("agentsList");

                  navigate("/manage-agent");
                },
                onError: () => {
                  message.error("ยกเลิกตัวแทนสำเร็จไม่สำเร็จ");
                },
              }
            );
          },
          onCancel() {
            //console.log("Cancel");
          },
        });
      },
    },
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomLeft">
      <IconWrapper>{dotdotdot}</IconWrapper>
    </Dropdown>
  );
};

export default DropDownAgent;

const IconWrapper = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  margin-top: 5px;
  hover: {
    background-color: #efefef;
  }
`;
